import React from "react";

const Tags = ({editorTags, setState}) => {
    return <div className="tagsName">
        <a data-tooltip={editorTags.length > 0 ? editorTags : null} onClick={() => setState({ open:'r-open', openType: "tags" })} className="success fl-l btni mr5" >
            Теги ({(editorTags.length > 0) ? editorTags.split(',').length : '0'})</a>
    </div>
};

export default Tags;